<template>
	<div
		class="rp-messenger-previous-orders-list"
		>
		<div class="rp-messenger-previous-orders-list__search">
			<el-input
				v-model="searchedOrderNumber"
				:placeholder="$t('orderList.orderSearchPlaceholder')"
				clearable
				@keyup.enter.native="searchOrders"
				@input="searchOrders"
			>
			<div slot="prepend" class="rp-messenger-previous-orders-list__search-icon">
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 384.376 393.988"><defs></defs><path class="a" fill="#666" d="M17.055,0H368.316a16.5,16.5,0,0,1,14.707,8.961,16.732,16.732,0,0,1-1.3,17.414L253.035,207.656c-.043.063-.09.121-.133.184a36.769,36.769,0,0,0-7.219,21.816v147.8a16.431,16.431,0,0,1-16.434,16.535,16.922,16.922,0,0,1-6.48-1.3l-72.312-27.574c-6.48-1.977-10.781-8.09-10.781-15.453V229.656a36.774,36.774,0,0,0-7.215-21.816c-.043-.062-.09-.121-.133-.184L3.645,26.367a16.717,16.717,0,0,1-1.3-17.406A16.5,16.5,0,0,1,17.055,0ZM148.586,195.992a56.931,56.931,0,0,1,11.1,33.664V347.234l66,25.164V229.656a56.909,56.909,0,0,1,11.1-33.664L361.719,20H23.648Zm0,0" transform="translate(-0.495)"/></svg>
			</div>
			</el-input>
		</div>
		<div class="rp-messenger-previous-orders-list__no-orders" v-if="!searchingOrder && searchedOrderNumber && !searchedOrder && showNotFound">
			<div><EmptyCart /></div>
			<div class="text-msg">{{ $t('orderList.noOrderFound', { orderId: searchedOrderNumber }) }}</div>
		</div>
		<div class="rp-messenger-previous-orders-list__no-orders" v-if="searchingOrder" v-loading="searchingOrder">
		</div>
		<template v-else>
			<div 
				class="rp-messenger-previous-orders-list__order-item rp-basic-card"
				v-for="(orderData, index) in orderList"
				:key="index"
				:class="getAnimation"
				:style="{
					animationDelay: index*100+'ms'
				}"
				>
				<OrderItem 
					:orderData="orderData"
					@action="handleOrderAction"
					:showViewButton="true"
					:actionsList="acitonsList"
				/>
			</div>
		</template>

		<div
			class="rp-messenger-previous-orders-list__load-more animated fast fadeInUp"
			:style="{
				animationDealy: (orderDetails.length+1)*100+'ms'
			}"
			>
			<button
				v-if="orderDetails.length >= 2 && !searchedOrderNumber"
				class="btn"
				:style="{ color: activeColor }"
				:disabled="loadingOrders"
				@click="$emit('onViewMoreOrders')"
				>
				<span v-if="!loadingOrders">{{$t('orderList.viewMoreOrders')}}</span>
				<i v-else class="el-icon-loading"/>
			</button>
		</div>
	</div>
</template>

<script>
import EmptyCart from '../../Images/EmptyCart'
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};
export default {
	name: "previousOrder",

	components: {
		EmptyCart
	},

	props: {
		orderDetails: {
			type: Array
		},

		activeColor: {
			type: String,
			required: true
		},

		loadingOrders: {
			type: Boolean,
			default: false,
		},

		getAnimation: {
			type: Array,
			required: true,
		}
	},

	watch: {
		searchedOrderNumber(val) {
			if(!val){
				this.searchedOrder = null;
				this.showNotFound = false;
			}
		}
	},

	data() {
		return {
			isOpenAllOrder: false,
			searchedOrderNumber: '',
			orderAddress: [],
			acitonsList: [
				{
					buttonLabel: 'help',
					actionName: 'onOrderHelpClick',
				},
				{
					buttonLabel: 'track',
					actionName: 'onOrderTrackUrlClick',
				}
			],
			searchedOrder: null,
			searchingOrder: false,
			showNotFound: false,
		}
	},

	computed: {
		orderList() {
			if(this.searchedOrder && this.searchedOrder.length &&  this.searchedOrderNumber) {
				return this.searchedOrder
			}
			if(this.searchingOrder){
				return []
			}
			if(this.searchedOrderNumber) {
				return []
			}
			return this.orderDetails
		}
		
	},

    methods: {
		handleOrderAction({ actionName, payload }) {
			this.$emit(actionName, payload)
		},

		searchOrders: debounce(async function (e) {
			if(!this.searchedOrderNumber) {
				this.searchingOrder = false;
				this.searchedOrder = null;
				return
			};
			try {
				this.searchingOrder = true;
				let order = await this.$parent.searchOrders(this.searchedOrderNumber, 'startswith');
				if(order && order.length){
					this.searchedOrder = order;
					this.showNotFound = false;
				} else {
					this.searchedOrder = null;
					this.showNotFound = true;
				}
				this.searchingOrder = false;
			} catch(e){
				console.log(e)
				this.searchingOrder = false;
				this.showNotFound = true;
			}
		}, 1000)
    }
};
</script>

<style lang="scss" scoped>
.rp-messenger-previous-orders-list {
	margin: 16px;
	.rp-messenger-previous-orders-list__order-item {
		+.rp-messenger-previous-orders-list__order-item {
			margin-top: 16px;
		}
	}
	.rp-messenger-previous-orders-list__load-more {
		text-align: center;
		margin-top: 1rem;
	}
	.rp-messenger-previous-orders-list__search {
		margin: 0px 0px 16px auto;
		max-width: 250px;
		.search-btn {
			background-color: var(--theme-background-color) !important;
			color: #fff;
			font-weight: bold;
			font-size: 21px;
			padding: 10px 20px;
			border-bottom-left-radius: 0px !important;
    		border-top-left-radius: 0px !important;
		}
		
		svg {
			vertical-align: middle;
			width: 20px;
			height: 20px;
		}
		
	}
	.rp-messenger-previous-orders-list__no-orders {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 50px;
		flex-direction: column;
		svg {
			height: 100px;
			width: 100px;
		}
		.text-msg {
			margin-top: 16px;
		}
	}
}
</style>
<style lang="scss">
	.rp-messenger-previous-orders-list__search {
		.el-input-group--prepend {
			.el-input-group__prepend {
				padding: 0px 14px !important;
				background: transparent !important;
			}
		}
	}
</style>
